const initMediaCarousel = () => {
    const mediaCarousel = document.querySelector('.Product--media');

    if (!mediaCarousel) return;

    const mainMediaScroller = mediaCarousel.querySelector('.Product--media-main');
    const mediaCarouselItems = mediaCarousel.querySelectorAll('.Product--image');
    const navigationButtons = Array.from(mediaCarousel.querySelectorAll('.Product--thumbnail'));

    const navScroller = mediaCarousel.querySelector('.Product--navigation-scroller');

    if(window.innerWidth > 768) {
        navScroller.style.setProperty('height', `${mainMediaScroller.offsetHeight}px`);
    }
    else{
        navScroller.style.setProperty('height', 'auto');
    }

    subscribe(PUB_SUB_EVENTS.contentAdded, (data)=>{
        const variantSelector = data.content.querySelector('.Variant_Picker select');

        if(variantSelector) {
            variantSelector.addEventListener('change', (event) => {
                const selectedVariant = event.target.value;
                const selectedOption = Array.from(variantSelector.options).find(option => option.value === selectedVariant);
    
                console.log(selectedOption);
    
                const selectedImageId = selectedOption.dataset.mediaId;
    
                const selectedIndex = Array.from(mediaCarouselItems).findIndex(item => item.dataset.imageId === selectedImageId);
                
                if (selectedIndex !== -1) {
                    mainMediaScroller.scrollTo({
                        top: mediaCarouselItems[selectedIndex].offsetTop,
                        behavior: 'smooth',
                    });
                    if(window.innerWidth > 768) {
                        navScroller.scrollTo({
                            top: navigationButtons[selectedIndex].offsetTop,
                            behavior: 'smooth',
                        });
                    }
                    else{
                        navScroller.scrollTo({
                            left: navigationButtons[selectedIndex].offsetLeft,
                            behavior: 'smooth',
                        });
                    }
                    navigationButtons.forEach((btn) => {
                        btn.classList.remove('Active');
                    });
                    navigationButtons[selectedIndex].classList.add('Active');
                }
            });
        }
    });

    const variantSelector = document.querySelector('.Variant_Picker select');

    if(variantSelector) {
        variantSelector.addEventListener('change', (event) => {
            const selectedVariant = event.target.value;
            const selectedOption = Array.from(variantSelector.options).find(option => option.value === selectedVariant);

            console.log(selectedOption);

            const selectedImageId = selectedOption.dataset.mediaId;

            const selectedIndex = Array.from(mediaCarouselItems).findIndex(item => item.dataset.imageId === selectedImageId);
            
            if (selectedIndex !== -1) {
                mainMediaScroller.scrollTo({
                    top: mediaCarouselItems[selectedIndex].offsetTop,
                    behavior: 'smooth',
                });
                if(window.innerWidth > 768) {
                    navScroller.scrollTo({
                        top: navigationButtons[selectedIndex].offsetTop,
                        behavior: 'smooth',
                    });
                }
                else{
                    navScroller.scrollTo({
                        left: navigationButtons[selectedIndex].offsetLeft,
                        behavior: 'smooth',
                    });
                }
                navigationButtons.forEach((btn) => {
                    btn.classList.remove('Active');
                });
                navigationButtons[selectedIndex].classList.add('Active');
            }
        });
    }

    let index = 0;

    navigationButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            index = navigationButtons.indexOf(button);
            mainMediaScroller.scrollTo({
                top: mediaCarouselItems[index].offsetTop,
                behavior: 'smooth',
            });

            navigationButtons.forEach((btn) => {
                btn.classList.remove('Active');
            });

            button.classList.add('Active');
        });
    });

    window.addEventListener('resize', () => {   
        mainMediaScroller.scrollTo({
            top: mediaCarouselItems[index].offsetTop,
            behavior: 'smooth',
        });

        if(window.innerWidth > 768) {
            navScroller.style.setProperty('height', `${mainMediaScroller.offsetHeight}px`);
        }
        else{
            navScroller.style.setProperty('height', 'auto');
        }

    });

}

initMediaCarousel()